export const SET_PREDICATES_LOADED = "SET_PREDICATES_LOADED";

export const setPredicatesLoaded = (predicatesLoaded: boolean) => {
  return {
    predicatesLoaded,
    type: SET_PREDICATES_LOADED
  };
};
